import { request } from './http-client'

const paymentService = {
  savedCards: (params: { branch_id?: string; type: string }) => {
    return request.get<{ cards: { id: string; cardMask: string }[] }>(
      '/v1/payment/saved-cards',
      { params }
    )
  },
  cardDelete: (id: string, params: { type: string }) =>
    request.delete('/v1/payment/saved-cards/' + id, { params }),
}

export default paymentService
